<p-dialog [(visible)]="showUploadDocumentsPopup"
            [modal]="true"
            [style]="{width: '800px', height: '668px'}"
            [draggable]="false"
            [resizable]="false"
            (onHide)="onDialogHide()"
            xmlns="http://www.w3.org/1999/html">
    <ng-template pTemplate="header">
        <span class="upload-files-header">Upload Business Documents</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="mt-3 mb-3 upload-accepted-label">Accepted Files: .pdf, .jpg, .jpeg, .png maximum of 5mb.</div>
        <div class="mt-3 flex">
            <div>
                <label class="document-label">DTI or SEC Certificate</label>
                <div class="mt-3 upload-dropzone" [ngClass]="{'error-dropzone': DTIorSECUploadError}" appDnd (fileDropped)="onFileDropped(BusinessDocumentsEnum.DTIorSECCertificate, $event)">

                    <label *ngIf="!DTIorSECProgressBar && !DTIorSECUploadError" class="dropfile-label text-very-small">Drop files here to upload...</label>
                    <label *ngIf="DTIorSECUploadError" class="error-label">There was a problem uploading the file</label>
                    <input style="display: none" type="file" id="DTIorSECCertificate" (change)="fileBrowseHandler(BusinessDocumentsEnum.DTIorSECCertificate, $event)">

                    <label *ngIf="!DTIorSECProgressBar && !DTIorSECUploadError" class="operator-btn browse-btn text-small-normal" for="DTIorSECCertificate">Browse Files</label>
                    <label *ngIf="DTIorSECUploadError" class="operator-btn try-again-btn text-small-bold" for="DTIorSECCertificate">Try again</label>
                    <span class="on-dragover text-very-small">Drop file here to upload...</span>

                    <div *ngIf="DTIorSECProgressBar && DTIorSECProgressBar < 100" class="mb-8 progress-cont">
                        <div class="progress" [ngStyle]="{ width: DTIorSECProgressBar + '%' }"></div>
                        <span class="mb-2 percent-complete text-very-small">{{DTIorSECProgressBar}}% Complete</span>
                        <div class="operator-btn cancel-btn text-small-bold" (click)="cancelUpload(BusinessDocumentsEnum.DTIorSECCertificate)">Cancel</div>
                    </div>

                    <div *ngIf="DTIorSECProgressBar === 100" style="width: 300px">
                        <div class="mb-1 flex justify-content-between" *ngFor="let file of profile.DTIorSECCertifData; let i = index">
                            <img src="{{Utils.getUploadedFileIcon(file?.type)}}" width="24px" alt="file">
                            <div class="common-font file-name">{{file?.name | slice:0:32}}</div>
                            <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file" (click)="deleteUpload(BusinessDocumentsEnum.DTIorSECCertificate, file)">
                        </div>
                    </div>

                </div>
            </div>
            <div style="width: 16px"></div>
            <div>
                <label class="document-label">BIR Certificate</label>
                <div class="mt-3 upload-dropzone" [ngClass]="{'error-dropzone': BIRUploadError}" appDnd (fileDropped)="onFileDropped(BusinessDocumentsEnum.BIRCertificate, $event)">

                    <label *ngIf="!BIRProgressBar && !BIRUploadError" class="dropfile-label text-very-small">Drop files here to upload...</label>
                    <label *ngIf="BIRUploadError" class="error-label">There was a problem uploading the file</label>
                    <input style="display: none" type="file" id="BIRCertificate" (change)="fileBrowseHandler(BusinessDocumentsEnum.BIRCertificate, $event)">

                    <label *ngIf="!BIRProgressBar && !BIRUploadError" class="operator-btn browse-btn text-small-normal" for="BIRCertificate">Browse Files</label>
                    <label *ngIf="BIRUploadError" class="operator-btn try-again-btn text-small-bold" for="BIRCertificate">Try again</label>
                    <span class="on-dragover text-very-small">Drop file here to upload...</span>

                    <div *ngIf="BIRProgressBar && BIRProgressBar < 100" class="mb-8 progress-cont">
                        <div class="progress" [ngStyle]="{ width: BIRProgressBar + '%' }"></div>
                        <span class="mb-2 percent-complete text-very-small">{{BIRProgressBar}}% Complete</span>
                        <div class="operator-btn cancel-btn text-small-bold" (click)="cancelUpload(BusinessDocumentsEnum.BIRCertificate)">Cancel</div>
                    </div>

                    <div *ngIf="BIRProgressBar === 100" style="width: 300px">
                        <div class="mb-1 flex justify-content-between" *ngFor="let file of profile.BIRCertifData; let i = index">
                            <img src="{{Utils.getUploadedFileIcon(file?.type)}}" width="24px" alt="file">
                            <div class="common-font file-name">{{file?.name | slice:0:32}}</div>
                            <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file" (click)="deleteUpload(BusinessDocumentsEnum.BIRCertificate, file)">
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="mt-3 flex">
            <div>
                <label class="document-label">LTFRB Certificate</label>
                <div class="mt-3 upload-dropzone" [ngClass]="{'error-dropzone': LTFRBUploadError}" appDnd (fileDropped)="onFileDropped(BusinessDocumentsEnum.LTFRBCertificate, $event)">

                    <label *ngIf="!LTFRBProgressBar && !LTFRBUploadError" class="dropfile-label text-very-small">Drop files here to upload...</label>
                    <label *ngIf="LTFRBUploadError" class="error-label">There was a problem uploading the file</label>
                    <input style="display: none" type="file" id="LTFRBCertificate" (change)="fileBrowseHandler(BusinessDocumentsEnum.LTFRBCertificate, $event)">

                    <label *ngIf="!LTFRBProgressBar && !LTFRBUploadError" class="operator-btn browse-btn text-small-normal" for="LTFRBCertificate">Browse Files</label>
                    <label *ngIf="LTFRBUploadError" class="operator-btn try-again-btn text-small-bold" for="LTFRBCertificate">Try again</label>
                    <span class="on-dragover text-very-small">Drop file here to upload...</span>

                    <div *ngIf="LTFRBProgressBar && LTFRBProgressBar < 100" class="mb-8 progress-cont">
                        <div class="progress" [ngStyle]="{ width: LTFRBProgressBar + '%' }"></div>
                        <span class="mb-2 percent-complete text-very-small">{{LTFRBProgressBar}}% Complete</span>
                        <div class="operator-btn cancel-btn text-small-bold" (click)="cancelUpload(BusinessDocumentsEnum.LTFRBCertificate)">Cancel</div>
                    </div>

                    <div *ngIf="LTFRBProgressBar === 100" style="width: 300px">
                        <div class="mb-1 flex justify-content-between" *ngFor="let file of profile.LTFRBCertifData; let i = index">
                            <img src="{{Utils.getUploadedFileIcon(file?.type)}}" width="24px" alt="file">
                            <div class="common-font file-name">{{file?.name | slice:0:32}}</div>
                            <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file" (click)="deleteUpload(BusinessDocumentsEnum.LTFRBCertificate, file)">
                        </div>
                    </div>

                </div>
            </div>
            <div style="width: 16px"></div>
            <div>
                <label class="document-label">Business Permit</label>
                <div class="mt-3 upload-dropzone" [ngClass]="{'error-dropzone': BusinessPermitUploadError}" appDnd (fileDropped)="onFileDropped(BusinessDocumentsEnum.BusinessPermit, $event)">

                    <label *ngIf="!BusinessPermitProgressBar && !BusinessPermitUploadError" class="dropfile-label text-very-small">Drop files here to upload...</label>
                    <label *ngIf="BusinessPermitUploadError" class="error-label">There was a problem uploading the file</label>
                    <input style="display: none" type="file" id="BusinessPermit" (change)="fileBrowseHandler(BusinessDocumentsEnum.BusinessPermit, $event)">

                    <label *ngIf="!BusinessPermitProgressBar && !BusinessPermitUploadError" class="operator-btn browse-btn text-small-normal" for="BusinessPermit">Browse Files</label>
                    <label *ngIf="BusinessPermitUploadError" class="operator-btn try-again-btn text-small-bold" for="BusinessPermit">Try again</label>
                    <span class="on-dragover text-very-small">Drop file here to upload...</span>

                    <div *ngIf="BusinessPermitProgressBar && BusinessPermitProgressBar < 100" class="mb-8 progress-cont">
                        <div class="progress" [ngStyle]="{ width: BusinessPermitProgressBar + '%' }"></div>
                        <span class="mb-2 percent-complete text-very-small">{{BusinessPermitProgressBar}}% Complete</span>
                        <div class="operator-btn cancel-btn text-small-bold" (click)="cancelUpload(BusinessDocumentsEnum.BusinessPermit)">Cancel</div>
                    </div>

                    <div *ngIf="BusinessPermitProgressBar === 100" style="width: 300px">
                        <div class="mb-1 flex justify-content-between" *ngFor="let file of profile.BusinessPermitData; let i = index">
                            <img src="{{Utils.getUploadedFileIcon(file?.type)}}" width="24px" alt="file">
                            <div class="common-font file-name">{{file?.name | slice:0:32}}</div>
                            <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file" (click)="deleteUpload(BusinessDocumentsEnum.BusinessPermit, file)">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pRipple class="btn-profile btn-default btn-border" (click)="updateFilesLinks()">Submit</button>
        <button class="btn-profile btn-default btn-discard-changes btn-cancel mr-3 btn-border" (click)="discardChanges()">Discard Changes</button>
    </ng-template>
    </p-dialog>
